import React, { useEffect } from "react";

import { useSelector, useDispatch } from "react-redux";

import { styled, Grid, Box, Typography } from "@mui/material";
import Item from "./components/Item";
import { getUserProfile } from "../../../../actions/user";
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';

const Root = styled("div")(({ theme }) => ({
  position: "relative", // Ensure positioning context for the pseudo-element
  margin: "0 auto",
  padding: "16px 16px 16px 16px",
  minHeight: "calc(100vh - 64px)",
  boxSizing: "border-box",
  paddingInline: "16vw",
  maxWidth: 1600,
  overflow: "hidden", // Ensure the pseudo-element does not overflow the container
  zIndex: 2,
  // Pseudo-element for the blurred background
  "&::before": {
    content: '""',
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundImage: "url(./assets/background/homeUser.jpg)",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    opacity: "0.9",
    filter: "blur(5px)",
    zIndex: 0, // Ensure it stays behind the content
  },

  [theme.breakpoints.down("sm")]: {
    paddingInline: "0",
    marginLeft: "0",
    width: "100%",
  },
}));
const BackgroundImg = styled("img")({
  position: "absolute",
  width: "100%",
  height: "calc(100% - 64px)",
  opacity: "0.8",
  filter: "blur(5px)",
  zIndex: "0",
});

const HomePage = () => {
  const dispatch = useDispatch();
  const { user: currentUser } = useSelector((state) => state.auth);
  const { result: userProfile } = useSelector((state) => state.userProfile);

  const items = currentUser.roles.includes("ROLE_ADMIN")
    ? [
        {
          link: "/admin/car_booking_management",
          title: "ระบบจัดการรถ",
          image: "/assets/Image/menuPicture/menu_logistics.png",
        },
        {
          link: "/admin/dashboard",
          title: "จัดการรถรับส่งกะ",
          image: "/assets/Image/typeOfCars/transparent_ShiftCar.png",
        },
        {
          link: "/admin/catering/requested_list",
          title: "รายการขอจัดเลี้ยง",
          image: "/assets/Image/menuPicture/menu_catering.png",
        },
        {
          link: "/admin/maintenances",
          title: "รายการแจ้งซ่อม",
          image: "/assets/Image/menuPicture/menu_maintenance.png",
        },
        {
          link: "/admin/Newmeetingroom/detailMeetingRoomBooking/",
          title: "รายการจองสถานที่",
          image: "/assets/Image/menuPicture/menu_meetingroom.png",
        },
        {
          link: "/admin/driverBooking_page",
          title: "รายการจองคนขับรถ",
          image: "/assets/Image/menuPicture/menu_driver.png",
        },
        {
          link: "/admin/setting/drop_site_pin",
          title: "ข้อมูลระบบ",
          image: <SettingsSuggestIcon />,
        },
      ]
    : [
        {
          link: "/catering/request_catering",
          title: "จัดงานเลี้ยง",
          image: "/assets/Image/menuPicture/menu_catering.png",
        },
        {
          link: "/maintenances/request",
          title: "บริการซ่อมแซม",
          image: "/assets/Image/menuPicture/menu_maintenance.png",
        },
        {
          link: "/carbooking",
          title: "บริการรถ",
          image: "/assets/Image/menuPicture/menu_logistics.png",
        },
        {
          link: "/meetingroom",
          title: "บริการสถานที่",
          image: "/assets/Image/menuPicture/menu_meetingroom.png",
        },
        {
          link: "/driverbooking",
          title: "บริการขอคนขับรถ",
          image: "/assets/Image/menuPicture/menu_driver.png",
        },
      ];

  useEffect(() => {
    if (!userProfile) {
      dispatch(getUserProfile(currentUser?.idUser));
    }
  }, []);

  return (
    <div className="page">
      <Root>
        <div
          style={{
            height: "100%",
            width: "100%",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Grid
            container
            sx={{ justifyContent: { xs: "center", sm: "flex-start" } }}
          >
            <Box
              sx={{
                zIndex: 10,
                paddingTop: "20px",
                paddingBottom: "20px",
              }}
            >
              <Typography
                variant="h5"
                sx={{
                  color: (theme) => `${theme.palette.text.primary}`,
                  justifyContent: { xs: "center", sm: "flex-start" },
                }}
              >
                {currentUser.roles.includes("ROLE_ADMIN")
                  ? "เมนูผู้ดูแลระบบ"
                  : "เมนูทางลัด"}
              </Typography>
            </Box>
            <Grid
              container
              spacing={2}
              sx={{ justifyContent: { xs: "center", sm: "flex-start" }, paddingBottom: "20px" }}
            >
              {items.map((item, index) => (
                <Grid item xs={8} sm={4} key={index}>
                  <Item
                    link={item.link}
                    title={item.title}
                    image={item.image}
                  />
                </Grid>
              ))}
            </Grid>
          </Grid>
        </div>
      </Root>
    </div>
  );
};

export default HomePage;
